import { getUserMailboxInfo, MailboxInfo } from 'owa-client-ids';
import { getMasterCategoryList } from 'owa-categories';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import type CategoryType from 'owa-service/lib/contract/CategoryType';

function getUserCategories(mailboxInfo: MailboxInfo): CategoryType[] {
    return getMasterCategoryList(mailboxInfo);
}

function getEmailAddressForAllAccounts(): string[] {
    return [getUserMailboxInfo().userIdentity].concat(
        getOWAConnectedAccounts().map(account => account.userIdentity)
    );
}

function includesCategory(categoryCompare: CategoryType, categories: CategoryType[]): boolean {
    for (let category of categories) {
        if (category.Name === categoryCompare.Name) {
            return true;
        }
    }
    return false;
}

export function getFilterCategories(): CategoryType[] {
    const emailAddresses = getEmailAddressForAllAccounts();
    const categories: CategoryType[] = [];
    for (let emailAddress of emailAddresses) {
        const userMailboxInfo = getUserMailboxInfo(emailAddress);
        const userCategories = getUserCategories(userMailboxInfo);
        for (let category of userCategories) {
            if (!includesCategory(category, categories)) {
                categories.push(category);
            }
        }
    }
    return categories;
}
